define("powergen/components/x-static-part",
  [],
  function() {
    "use strict";
    var XStaticPartComponent;

    XStaticPartComponent = Ember.Component.extend({
      tagName: 'div',
      classNames: ['static-part'],
      classNameBindings: ['staticPart.id', 'staticPart.part.id'],
      attributeBindings: ['style'],
      style: (function() {
        return this.get('util').styleString({
          'width': '%@px'.fmt(this.get('staticPart.size.width')),
          'height': '%@px'.fmt(this.get('staticPart.size.height')),
          'left': '%@px'.fmt(this.get('staticPart.position.x')),
          'top': '%@px'.fmt(this.get('staticPart.position.y'))
        });
      }).property('staticPart.position.x', 'staticPart.position.y')
    });


    return XStaticPartComponent;
  });